import { RoutePaths } from 'routes/routes';
import { intakeFormAPI } from 'api/crm/intakeFormAPI';
import { customHistory } from 'constants/customHistory';
import { applicationsAPI } from 'api/application/applicationsAPI';
import { setLayoutVariant } from './settings';
import { initUserPermissions } from './userAccess';
import { setInitializedStatus } from './app';
import { cleanUpApplicationsReducer } from './applications';
import {
  setActiveApplicationId,
  setActiveIntakeFormId,
  setAuthenticationTokens,
} from 'helpers/localStorageHelpers';
import { IntakeFormData } from 'redux/reducers/intakeForm';

// Actions
export enum ActionType {
  SET_INTAKE_FORM_ID = 'intakeForm/SET_INTAKE_FORM_ID',
  SET_INTAKE_FORM = 'intakeForm/SET_INTAKE_FORM',
  SET_INTAKE_SUBMISSIONS = 'intakeForm/SET_INTAKE_SUBMISSIONS',
  CLEAN_UP = 'intakeForm/CLEAN_UP',
}

// Action creators
export const setIntakeForm = (intakeForm: IntakeFormData | null) => ({
  type: ActionType.SET_INTAKE_FORM,
  payload: intakeForm,
});
export const setIntakeSubmissions = (intakeSubmissions: IntakeFormData[]) => ({
  type: ActionType.SET_INTAKE_SUBMISSIONS,
  payload: intakeSubmissions,
});

export const cleanUpIntakeFormReducer = () => ({
  type: ActionType.CLEAN_UP,
  payload: null,
});

export const selectIntakeForm = (formId: string) => async (dispatch: any) => {
  dispatch(setInitializedStatus(false));
  const { clientIntakeSubmission } =
    await intakeFormAPI.fetchIntakeFormById(formId);
  dispatch(setIntakeFormId(formId));
  await dispatch(
    setIntakeForm({
      _id: clientIntakeSubmission._id,
      hrid: clientIntakeSubmission.hrid,
      state: clientIntakeSubmission.state,
      type: clientIntakeSubmission.type,
      directClientName: clientIntakeSubmission.fields.entityLegalName || '',
      keyRelationshipTemplateName:
        clientIntakeSubmission.metadata.keyRelationshipTemplateInstance.name,
    }),
  );
  await dispatch(cleanUpApplicationsReducer());
  const { token, permissions } =
    await applicationsAPI.selectIntakeSubmissionForm();
  setAuthenticationTokens(token.jwt, token.refreshToken);
  await dispatch(initUserPermissions(permissions));
  await dispatch(setLayoutVariant('IntakeForm'));
  setActiveApplicationId(null);
  setActiveIntakeFormId(formId);
  dispatch(setInitializedStatus(true));
  customHistory.push(RoutePaths.IntakeFormPage);
};

export const setIntakeFormId = (id: string) => ({
  type: ActionType.SET_INTAKE_FORM_ID,
  payload: id,
});
